import React from "react";
import { Grid2 } from "@mui/material";
import ReadMoreIcon from "@mui/icons-material/ReadMore";
import styles from "./DomainInfo.module.scss";

export function DomainInfo(props) {
  const { domainText } = props;
  return (
    <>
      {domainText.map((item, index) => (
        <Grid2 key={index} className={styles.primaryDomain}>
          <Grid2 className={styles.text}>{item.header}</Grid2>
          <Grid2 className={styles.subText}>{item.subHeader}</Grid2>
          <Grid2
            className={styles.readMoreFlex}
            onClick={() => window.open(item.readMore, "_blank")}
          >
            <Grid2 className={styles.readMore}>Read More</Grid2>
            <ReadMoreIcon className={styles.readIconColor} />
          </Grid2>
        </Grid2>
      ))}
    </>
  );
}
